export { Icon, SVG_TRANSFORMS } from './Icon';
export type { IconProps } from './Icon';
export * from './SizedIcon';
